import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../../../constants/general-constants";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default function UtilisationChartBarBreakdown({}){
	
	const chartId1 = "utilisationchartbarbreakdown1";
	const chartId2 = "utilisationchartbarbreakdown2";
	
	const chartData1 = [
		{label:'Single Desk Workstation', occupied:"30", signsoflife:"20", unused:"10"},
		{label:'Pod', occupied:"10", signsoflife:"10", unused:"40"},
		{label:'Meeting Room', occupied:"30", signsoflife:"0", unused:"30"},
		{label:'Sit Out Area', occupied:"40", signsoflife:"10", unused:"10"},
		{label:'Kitchen', occupied:"10", signsoflife:"0", unused:"10"},
		{label:'Reception', occupied:"30", signsoflife:"0", unused:"10"}
		
	];
	
	const graphs1 = [
		{title:"Occupied", keyColumn:"occupied", color:"darkblue"},
		{title:"Signs Of Life", keyColumn:"signsoflife", color:"lightblue"},
		{title:"Unused", keyColumn:"unused", color:"#eee"}
	];
	
	const chartData2 = [
		{label:'Single Desk Workstation', occupied:"150", signsoflife:"0", unused:"0"},
		{label:'Pod', occupied:"150", signsoflife:"0", unused:"0"},
		{label:'Meeting Room', occupied:"130", signsoflife:"40", unused:"30"},
		{label:'Sit Out Area', occupied:"140", signsoflife:"10", unused:"10"},
		{label:'Kitchen', occupied:"110", signsoflife:"50", unused:"60"},
		{label:'Reception', occupied:"130", signsoflife:"50", unused:"30"}
		
	];
	
	const graphs2 = [
		{title:"Average % Capacity", keyColumn:"occupied", color:"darkgreen"},
		{title:"% Time Over 90% Capacity", keyColumn:"signsoflife", color:"lightgreen"},
		{title:"% Time UNder 10% Capacity", keyColumn:"unused", color:"red"}
	];
	
	useEffect(() => {
		let categoryKey = "label";
		
		let x = am4core.create(chartId1, am4charts.XYChart);
		x.fontSize = 10;
    x.fill='black';
    x.strokeAlpha=0;
		x.paddingTop = 0;
		x.paddingRight = 0;
		x.paddingLeft = 0;
		x.paddingBottom = 0;
		let categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.renderer.grid.template.strokeOpacity = 0;
		categoryAxis.renderer.labels.template.strokeOpacity=0;
		categoryAxis.renderer.labels.template.fillOpacity=1;
		categoryAxis.dataFields.category=categoryKey;	
		categoryAxis.renderer.labels.template.rotation=0;
		categoryAxis.renderer.minGridDistance = 15;
		categoryAxis.renderer.inversed=true;
		categoryAxis.renderer.labels.template.horizontalCenter = "right";
		
		let valueAxis = x.xAxes.push(new am4charts.ValueAxis());
		valueAxis.renderer.grid.template.strokeOpacity = 0;
		valueAxis.renderer.labels.template.strokeOpacity=0;
		valueAxis.renderer.labels.template.fillOpacity=0;
		
		for(let i=0; i<graphs1.length; i++){
	 		let series = x.series.push(new am4charts.ColumnSeries());
	 		series.name = graphs1[i].title;
	    series.dataFields.categoryY = categoryKey;
	    series.dataFields.valueX = graphs1[i].keyColumn;
	    series.fill = graphs1[i].color;
	    series.stroke = graphs1[i].color;
	    series.tooltipText = graphs1[i].title + " ({categoryY}): {valueX}";
  		series.tooltip.label.wrap=true;
  		series.tooltip.label.width=300;
  		series.tooltip.label.fill='black';
  		series.stacked=true;
	  }
	   
	   x.cursor = new am4charts.XYCursor();
	   
			x.data = chartData1;
			chart1.current = x;
	}, [chartData1, graphs1]);
	
	useEffect(() => {
		let categoryKey = "label";
		
		let x = am4core.create(chartId2, am4charts.XYChart);
		x.fontSize = 10;
    x.fill='black';
    x.strokeAlpha=0;
		x.paddingTop = 0;
		x.paddingRight = 0;
		x.paddingLeft = 0;
		x.paddingBottom = 0;
		let categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.renderer.grid.template.strokeOpacity = 0;
		categoryAxis.renderer.labels.template.strokeOpacity=0;
		categoryAxis.renderer.labels.template.fillOpacity=0;
		categoryAxis.dataFields.category=categoryKey;	
		categoryAxis.renderer.labels.template.rotation=0;
		categoryAxis.renderer.inversed=true;
		
		let valueAxis = x.xAxes.push(new am4charts.ValueAxis());
		valueAxis.renderer.grid.template.strokeOpacity = 0;
		valueAxis.renderer.labels.template.strokeOpacity=0;
		valueAxis.renderer.labels.template.fillOpacity=0;
		
		for(let i=0; i<graphs2.length; i++){
	 		let series = x.series.push(new am4charts.ColumnSeries());
	 		series.name = graphs2[i].title;
	    series.dataFields.categoryY = categoryKey;
	    series.dataFields.valueX = graphs2[i].keyColumn;
	    series.fill = graphs2[i].color;
	    series.stroke = graphs2[i].color;
	    series.tooltipText = graphs2[i].title + " ({categoryY}): {valueX}";
  		series.tooltip.label.wrap=true;
  		series.tooltip.label.width=300;
  		series.tooltip.label.fill='black';
  		if(i === 0){
  			series.columns.template.height = am4core.percent(99);
  		}
  		else{
  			series.columns.template.height = am4core.percent(30);
  		}
  		
  		if(i === 1){
  			series.stacked=false;
  		}
  		else{
  			series.stacked=true;
  		}
  		
	  }
	   
	   x.cursor = new am4charts.XYCursor();
	   
			x.data = chartData2;
			chart2.current = x;
	}, [chartData2, graphs2]);
	
	const chart1 = useRef(null);
	const chart2 = useRef(null);
	
	
	const thisContainer = {
		display:'flex',
		marginLeft:"20px",
		paddingTop:"20px",
		paddingBottom:"20px",
		width:"calc(100% - 32px)",
		height:"48vh",
		fontWeight:"bold",
		flexDirection:"column",
		borderTop:"1px solid lightgrey",
		borderBottom:"1px solid lightgrey"
	};
	
	const topContainer = {
		display:"flex",
		width:"100%",
		alignItems:"center",
		marginBottom:"20px"
	}
	
	const chartTitle = {
		display:"flex",
		fontSize:"14px",
		marginRight:"10px"
	}
	
	const selectStyle = {
		display:"flex",
		height:"25px",
		paddingLeft:"10px",
		border:"1px solid lightgrey",
		borderRadius:"5px",
		width:"200px"
	};
	
	const chartContainer ={ 
		display:"flex",
		width:"100%",
		height:"calc(100% - 80px)"
	};
	
	
	
	const chartContainer1 = {
		display:'flex',
		width:"80%"
	};
	
	const chartContainer2 = {
		display:'flex',
		width:"70%",
		marginLeft:"-200px"
	};
	
	const keyContainer = {
		display:"flex",
		alignSelf:"center",
		alignItems:"center",
		flexWrap:"wrap",
		width:"410px"
	};
	
	const keyKey = {
		display:"flex",
		width:"16px",
		height:"16px",
		borderRadius:"8px"
	};
	
	const keyLabel = {
		display:"flex",
		marginLeft:"10px",
		marginRight:"20px",
		fontSize:"12px",
		fontWeight:"normal",
		height:"20px",
		alignItems:"center",
		width:"90px"
	};
	
	return (
		<div style={thisContainer}>
			<div style={topContainer}>
				<div style={chartTitle}>
					Utilisation by: 
				</div>
				<select style={selectStyle}>
					<option>Space Type</option>
					<option>Location</option>
					<option>Floor</option>
					<option>Function</option>
					<option>Division/Team</option>
				</select>
			</div>
			<div style={chartContainer}>
				<div style={chartContainer1} id={chartId1}>
			
				</div>
				<div style={chartContainer2} id={chartId2}>
			
				</div>
			</div>
			<div style={keyContainer}>
				<div style={{...keyKey, backgroundColor:'darkblue'}}/>
				<div style={keyLabel}>
					Occupied
				</div>
				<div style={{...keyKey, backgroundColor:'lightblue'}}/>
				<div style={keyLabel}>
					Signs of Life
				</div>
				<div style={{...keyKey, backgroundColor:'darkgreen'}}/>
				<div style={keyLabel}>
					Avg % Capacity
				</div>
				<div style={{...keyKey, backgroundColor:'green'}}/>
				<div style={keyLabel}>
					Over 90% Cap
				</div>
				<div style={{...keyKey, backgroundColor:'red'}}/>
				<div style={keyLabel}>
					Under 10% Cap
				</div>
			</div>
		</div>
	);
}